<template>
  <div
    :data-color="activeColor"
    :data-image="backgroundImage"
    :data-background-color="backgroundColor"
    :style="sidebarStyle"
    class="sidebar"
  >
    <div class="logo">
      <a href="" class="simple-text logo-mini">
        <div>
          <img :src="logo" />
        </div>
      </a>
      <span @click="goToDashboard" style="" class="simple-text logo-normal">
        <template>{{ title }}</template>
      </span>
      <div class="navbar-minimize">
        <md-button
          id="minimizeSidebar"
          class="md-round md-just-icon md-transparent"
          @click="minimizeSidebar"
        >
          <i class="material-icons text_align-center visible-on-sidebar-regular"
            >more_vert</i
          >
          <i
            class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
            >view_list</i
          >
        </md-button>
      </div>
    </div>

    <div ref="sidebarScrollArea" class="sidebar-wrapper">
      <slot />
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            />
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/img/GlobeChek_EYE.png";
export default {
  name: "Sidebar",
  props: {
    title: {
      type: String,
      default: "GlobeChek",
    },
    activeColor: {
      type: String,
      default: "azure",
      validator: (value) => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "", // "./img/sidebar-0.jpg"
    },
    backgroundColor: {
      type: String,
      default: "white",
      validator: (value) => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: logo,
    },
    brand: {
      type: String,
      default: "./img/GlobeChek.png",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true, //Nra: CHANGED TO false
    },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    goToDashboard() {
      this.$router.push("/globe-chek/dashboard");
    },
  },
};
</script>

<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
